import * as React from 'react';
import { SortDirection } from '@deltasierra/react-hooks';
import './SortableHeaderButton.scss';

export type SortableHeaderButtonProps = {
    label: string;
    direction: SortDirection;
    onClick: () => void;
};

function SortableHeaderButton(props: SortableHeaderButtonProps): React.ReactElement<SortableHeaderButtonProps> {
    return (
        <span className="sortable-header-button" onClick={props.onClick}>
            {props.label}
            <div className="text-primary" style={{ display: 'inline-block', width: 20 }}>
                {props.direction !== null && (
                    <i
                        className={
                            props.direction === 'asc'
                                ? 'glyphicon glyphicon-arrow-up'
                                : 'glyphicon glyphicon-arrow-down'
                        }
                    />
                )}
            </div>
        </span>
    );
}

SortableHeaderButton.displayName = 'SortableHeaderButton';

export default SortableHeaderButton;
